'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { sendGA } from '@/app/cc/_util/sendGA';
import styles from '@/app/cc/himart/_component/CouponBanner.module.scss';
export default function CouponBanner() {
  const [isOpen, setIsOpen] = useState(true);

  return isOpen ? (
    <div className={styles.coupon_banner}>
      <div className={styles.coupon_banner_wrapper}>
        <div className={styles.coupon_banner_content}>
          <Image src="/cc/image/himart/himart_coupon_logo.svg" alt="himart_coupon_logo" width={92} height={46} />
          <span className={styles.coupon_banner_content_title}>
            <span className={styles.highlight_text}>하이마트 </span>
            방문 고객을 위한 <br className={styles.br} />
            안심케어 쿠폰 혜택
          </span>
        </div>
        <div className={styles.coupon_banner_button_wrapper}>
          <Link href="/coupon" className={styles.coupon_banner_button} onClick={() => sendGA('couponClick')}>
            쿠폰 받기
            <Image
              className={styles.coupon_banner_button_arrow}
              src="/cc/image/icon_banner_arrow.svg"
              alt="arrow_right"
              width={8}
              height={16}
            />
          </Link>
          <button className={styles.close_button_desktop} type="button" onClick={() => setIsOpen(false)}>
            닫기
          </button>
          <button className={styles.close_button_mobile} type="button" onClick={() => setIsOpen(false)}>
            <Image src="/cc/image/icon_X.svg" alt="close" width={40} height={40} />
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div className={styles.coupon_banner_close} />
  );
}
